import logo from './logo.svg';
import './App.css';
import NavBarNew from './components/CourseNav/NavBarNew';
import SecondScreen from './screens/SecondScreen';
import FirstScreen from './screens/FirstScreen';
import FormScreen from './form/FormScreen';
import AboutMe from './components/me/Me';
import ThirdScreen from './screens/ThirdScreen';
import EligibilitySection from './components/fit/WhoFits';
import ByMe from './components/ByMe/ByMe';
import ForthScreen from './screens/ForthScreen';
import AdditionalCourses from './components/courses/Courses';
import PrivacyPolicy from './privacy/Privacy';

function App() {
return <>
    <NavBarNew/>
    <FirstScreen/>
    <SecondScreen/>
    <AboutMe/>

    <ThirdScreen/>

    <EligibilitySection/>
        <FormScreen title="זמן לקבל החלטה"/>
      <AdditionalCourses/>
    <FormScreen title="זמן לקבל החלטה"/>

    <ForthScreen/>
        <PrivacyPolicy 
  ownerName="נתי ונטורה" 
  email="Natish1301@gmail.com" 
  phone="+972 54-728-9417" 
  domain="https://nati-beauty-academy.co.il/" 
/>
    <ByMe/>
  </>
}

export default App;
